import { render } from "./TabsPage.vue?vue&type=template&id=b355aeda&scoped=true&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=b355aeda&scoped=true&lang=scss"

import exportComponent from "C:\\git\\PolkaDot2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b355aeda"]])

export default __exports__